import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-image',
    templateUrl: './home-image.component.html',
    styleUrls: ['./home-image.component.scss'],
    standalone: false
})
export class HomeImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
